import { FinalizeSpkUnstakeAction } from '../types'
import { spkStakingModuleAddress, spkStakingModuleConfig } from '@/config/contracts-generated'
import { getContractAddress } from '@/domain/hooks/useContractAddress'
import { getBalancesQueryKeyPrefix } from '@/domain/wallet/getBalancesQueryKeyPrefix'
import { ensureConfigTypes } from '@/features/actions/logic/transactions/useWrite'
import { ActionConfig, ActionContext } from '@/features/actions/logic/types'
import { spkStakingDataQueryKey } from '@/features/spk/staking/logic/useSpkStakingData'

export function createFinalizeSpkUnstakeActionConfig(
  action: FinalizeSpkUnstakeAction,
  context: ActionContext,
): ActionConfig {
  const { account, chainId } = context
  const vault = getContractAddress(spkStakingModuleAddress, chainId)

  return {
    getWriteConfig: () => {
      const { epochs } = action

      return ensureConfigTypes({
        address: vault,
        abi: spkStakingModuleConfig.abi,
        functionName: 'claimBatch',
        args: [account, epochs.map(BigInt)],
      })
    },

    invalidates: () => {
      return [getBalancesQueryKeyPrefix({ account, chainId }), spkStakingDataQueryKey({ account, chainId })]
    },
  }
}
